import React, { useState } from "react";
import classes from "./FrequencyDropdown.module.scss";
import FrequencyIcon from "../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/FrequencyIcon";
import useComponentVisible from "../../../../hooks/useComponentVisible";
import DropdownIcon from "../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/DropdownIcon";
import { useSelector } from "react-redux";

const FrequencyDropdown = ({
  valueArr,
  onSelectChange,
  frequencyVal,
  shotclassId,
}) => {
  const [ref, isComponentVisible, setIsComponentVisible] =
    useComponentVisible();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [selectedVal, setSelectedVal] = useState(
    frequencyVal === "NONE" || !frequencyVal ? "Select" : frequencyVal
  );
  const [hoverState, setHoverState] = useState(false);

  return (
    <div className={classes.dropdown}>
      <button
        className={hoverState ? classes.dropbtnActive : classes.dropbtn}
        onClick={(e) => {
          e.stopPropagation();
          setIsComponentVisible(!isComponentVisible);
        }}
        onMouseEnter={() => setHoverState(true)}
        onMouseLeave={() => setHoverState(false)}
      >
        <FrequencyIcon fill={hoverState ? "#fff" : "#404040"} />
        {selectedVal}
        <DropdownIcon
          fill={hoverState ? "#fff" : "#404040"}
          bg={hoverState ? colors?.theme : "#fff"}
        />
      </button>
      {isComponentVisible && (
        <div className={classes.dropdownContent} ref={ref}>
          <span className={classes.item}>Frequency</span>
          {valueArr?.map((data) => {
            return (
              <span
                className={
                  selectedVal === data?.val
                    ? classes.item + " " + classes.selectedItem
                    : classes.item
                }
                key={data?.val}
                onClick={() => {
                  onSelectChange(data?.val, shotclassId);
                  setSelectedVal(data?.val);
                  setIsComponentVisible(!isComponentVisible);
                }}
              >
                {data?.val}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FrequencyDropdown;
